import React from 'react'
import { Button, Container, Row, Card, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons'

const QISoftwareCards = () => {
    return (<>

        <Container className="outerContainer">
            <Row>
                <Col md={6} className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/SAS-QI.png" />
                        <Card.Body>
                            <Card.Title>SAS QI v2021</Card.Title>
                            <Card.Text>
                                Ideal for advanced users to run in a SAS/STAT software package
                            </Card.Text>
                            <Link
                                className="btn btn-primary mb-2"
                                role="button"
                                to="/software/sas_qi"
                            >
                                SAS QI v2021
                            </Link>
                            <Link
                                to="/archive/software?1#SAS-Release-Notes"
                                className="block"
                            >
                                Get Archived SAS QI Software
                            </Link> 
                        </Card.Body>

                    </Card>
                </Col>

                <Col md={6} className='stretchCard'>
                    <Card className="mb-4">
                        <Card.Img variant="top" src="/images/QI-ContactUs.jpg" />
                        <Card.Body>
                            <Card.Title>WinQI v2021</Card.Title>
                            <Card.Text>
                                WinQI’s robust user interface is ideal for non-programmers
                            </Card.Text>
                            <Link
                                className="btn btn-primary mb-2"
                                role="button"
                                to="/software/win_qi"
                            >
                                WinQI v2021
                            </Link>                            
                            <Link
                                className="block"
                                to="/archive/software?2#WinQI-Software"
                            >
                                Get Archived WinQI Software
                            </Link>                        
                            </Card.Body>
                    </Card>
                </Col>
            </Row>        
            </Container>
    </>)
}

export default QISoftwareCards;